"use client";

import { useCommunityContext } from "@/providers/community-provider";
import { COUNTRY_AUSTRIA_DATA, COUNTRY_BANGLADESH_DATA, COUNTRY_GERMANY_DATA, COUNTRY_INDIA_DATA, COUNTRY_LATAM_DATA, COUNTRY_UAE_DATA, COUNTRY_UNITED_STATES_DATA, CountryProvider } from "@/providers/country-provider";
import { ReactNode, useMemo } from "react";

interface CommunityCountryProviderProps {
	children: ReactNode;
}

export const CommunityCountryProvider = ({ children }: CommunityCountryProviderProps) => {
	const { communityInfo } = useCommunityContext();
	const communitySlug = communityInfo?.slug;

	const countryData = useMemo(() => {
		switch (communitySlug) {
			case "proptech-india":
				return COUNTRY_INDIA_DATA;
			case "proptech-uae":
				return COUNTRY_UAE_DATA;
			case "proptech-austria":
				return COUNTRY_AUSTRIA_DATA;
			case "proptech-germany":
				return COUNTRY_GERMANY_DATA;
			case "proptech-bangladesh":
				return COUNTRY_BANGLADESH_DATA;
			case "latam":
				return COUNTRY_LATAM_DATA;
			default:
				return COUNTRY_UNITED_STATES_DATA;
		}
	}, [communitySlug]);

	return (
		<CountryProvider countryData={countryData}>
			{children}
		</CountryProvider>
	);
};
